import React, {memo} from "react";
import { ContactLink } from "bukku/components/ContactLink";

function ContactName(props: {
    contact_id?: number;
    contact_name?: string;
    contact_code?: string;
}): React.ReactNode {
    const { contact_id, contact_name, contact_code } = props;
    let contactContent: React.ReactNode = contact_name || '-';

    if (contact_id) {
        contactContent = (
            <ContactLink
                contactId={contact_id}
                label={contact_name || '-'}
                contactCode={contact_code || ''}
                newWindow
            />
        );
    }
    else if (contact_name && contact_code) {
        contactContent = contact_name;
    }

    return (
        <div className="BaseTable__row-cell-text">
            {contactContent}
        </div>
    );
}

export default memo(ContactName);
